import { NotificationStatus } from './index';

export class NotificationsConstants {
  public static readonly ALL_SENT_STATUSES = [
    NotificationStatus.sent,
    NotificationStatus.read,
    NotificationStatus.deleted,
  ];

  public static readonly ALL_READ_STATUSES = [NotificationStatus.read, NotificationStatus.deleted];
}
